export default __webpack_public_path__ + "static/media/ocean-dark.eefe5027.svg";